

























import Animation from '@getaccept/lib-shared/src/components/Animation.vue';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  components: {
    Animation,
  },
  props: {
    hideBorderRadius: {
      type: Boolean,
      default: false,
    },
    shouldPopStripe: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const animationDelay = 1000;

    const handleAnimationLoaded = (animation: any) => {
      setTimeout(() => {
        animation.play();
      }, animationDelay);
    };

    return {
      handleAnimationLoaded,
    };
  },
});
